import { render, staticRenderFns } from "./ActivitySubjectDetailList.vue?vue&type=template&id=5fc0189a&scoped=true&"
import script from "./ActivitySubjectDetailList.vue?vue&type=script&lang=js&"
export * from "./ActivitySubjectDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0189a",
  null
  
)

export default component.exports